var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTcbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.19,
    height: 20.302,
    viewBox: "0 0 27.19 20.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#6868bf}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_group_24px",
    d: "M19.538 12.415a3.708 3.708 0 1 0-3.708-3.708 3.692 3.692 0 0 0 3.708 3.708zm-9.887 0a3.708 3.708 0 1 0-3.707-3.707 3.692 3.692 0 0 0 3.707 3.707zm0 2.472C6.772 14.887 1 16.333 1 19.213V25.3h17.3v-6.09c0-2.877-5.769-4.323-8.649-4.323zm9.887 0c-.358 0-.766.025-1.2.062a5.215 5.215 0 0 1 2.435 4.264V23.3h7.417v-4.09c0-2.877-5.772-4.323-8.652-4.323z",
    className: "cls-1",
    transform: "translate(-1 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTcbase);
export default __webpack_public_path__ + "static/media/icon_tcbase.003252c45ca32c01be4d2f36e548ee47.svg";
export { ForwardRef as ReactComponent };